import { Grid, InfoIcon, InfoIconColor } from '@focaldata/cin-ui-components'
import { TextHighlight, TextWeight } from '../../../constants/text'
import {
  DraftStandardAudience,
  FieldworkAudienceCriterionOption,
  MemberSettingCode
} from '../../../data/model/audience'
import { proportionToPercent } from '../../../utils/HelperFunctions'
import { overlayOptionValue } from '../audienceTranslation'
import { getEffectiveCriterionOptions, getIsEnabledInSettings } from '../utils'
import useStyles from './StandardAudienceSummaryItem.styles'

interface Props {
  audience: DraftStandardAudience
  // The active market's locale language; option values are overlaid to it.
  marketLanguage?: string
  hasError?: boolean
  showQuotas?: boolean
}

const StandardAudienceSummaryItem = ({
  audience,
  marketLanguage,
  hasError,
  showQuotas
}: Props) => {
  const { settingValues, criterion } = audience
  const { classes } = useStyles()
  const areQuotasOn = getIsEnabledInSettings(
    settingValues,
    MemberSettingCode.Quotas
  )

  const qualifyingOptions: FieldworkAudienceCriterionOption[] =
    getEffectiveCriterionOptions(audience).filter(
      (option) => option.qualification
    )

  const lastIndex: number = qualifyingOptions.length - 1

  return (
    <Grid className={classes.item}>
      <Grid container direction="row" alignItems="center">
        <p style={{ fontWeight: TextWeight.SemiBold }}>{criterion.name}</p>
        {hasError && (
          <InfoIcon
            iconColor={InfoIconColor.Error}
            text="There are errors in your targeting and sampling. You’ll need to resolve them before launch."
          />
        )}
      </Grid>

      <Grid container direction="row">
        {qualifyingOptions.map(
          (option: FieldworkAudienceCriterionOption, index: number) => {
            return (
              <div
                className={classes.optionContainer}
                key={option.criterionOption.code}
              >
                <p
                  style={{
                    fontWeight: TextWeight.SemiBold,
                    color: TextHighlight.Background
                  }}
                >
                  {overlayOptionValue(
                    option.criterionOption.responseOption.value,
                    option.criterionOption.responseOption.translations,
                    marketLanguage
                  )}
                  {showQuotas && areQuotasOn && option.quota && (
                    <span style={{ fontWeight: 400 }}>
                      {`\xa0(${proportionToPercent(option.quota.percent)}%)`}
                    </span>
                  )}
                  {index < lastIndex && ',\xa0'}
                </p>
              </div>
            )
          }
        )}
      </Grid>
    </Grid>
  )
}

export default StandardAudienceSummaryItem
